import React, {useEffect, useContext} from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import BackButton from "./BackButton"
import NextButton from "./NextButton";
import getNextPage from "./getNextPage";
import {RouterContext} from "./Onboarding"

export default function PPCConfigurationIntro(props) {
  const route = useContext(RouterContext)

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem(
      "routerHistory",
      JSON.stringify([...route.get])
    );
  }, [route.get]);
  props.pageLocator()
  return (
    <>
      <Row className=" px-4 mb-3 pb-3 justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Next Up: PPC Configuration</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">Now we will configure the PPC services. You will be able to set up campaign groups, inflation, scripts, and also manage all of your goals for each subservice.</p>
          </div>
        </Col>
      </Row>
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton smaller />
            <NextButton
              validated={true} 
              btnText={`Let's do it`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
              className="goBtn"
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
